var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions},nativeOn:{"dblclick":function($event){return _vm.onDblClick.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }